var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("p", {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "4px"
    }
  }, [_vm._v("当前版本为0.01试用版本，可满足最简单的流程功能，未完成功能，如脚本节点，邮件节点等目前暂时注释入口，期待大家PR")]), _c("el-button", {
    staticStyle: {
      float: "right",
      "margin-top": "6px",
      "margin-right": "6px"
    },
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.saveXML
    }
  }, [_vm._v("导出XML")]), _c("el-button", {
    staticStyle: {
      float: "right",
      "margin-top": "6px",
      "margin-right": "6px"
    },
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.saveImg
    }
  }, [_vm._v("导出图片")]), _c("el-popover", {
    attrs: {
      placement: "bottom",
      width: "160"
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("p", [_vm._v("确认流程无误并保存吗")]), _c("div", {
    staticStyle: {
      "text-align": "right",
      margin: "0"
    }
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "text"
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("取消")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      disabled: _vm.$route.query.type == "view"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确定")])], 1), _c("el-button", {
    staticStyle: {
      float: "right",
      "margin-top": "6px",
      "margin-right": "6px"
    },
    attrs: {
      slot: "reference",
      size: "small"
    },
    slot: "reference"
  }, [_vm._v("保存流程")])], 1), _vm.done ? _c("gva-wfd", {
    ref: "wfd",
    attrs: {
      data: _vm.demoData,
      height: 600,
      users: _vm.users,
      authorities: _vm.authorities,
      groups: _vm.groups,
      categorys: _vm.categorys,
      lang: _vm.lang,
      propProcessModel: _vm.processModel
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };